/* Callowfit conversion blocks: cut-off countdown, delivery estimate, free-bottle +
   free-shipping progress, shipping-cost preview, cart discount field, one-click
   recommendation add. Config comes from snippets/cf-cro-config.liquid.
   Markup is Liquid-rendered (cf-trust, free-shipping-under-atc, cart-footer,
   cart-recommendations); this file only fills data-cf-* nodes, so it survives the
   drawer's innerHTML swaps in cart.js. */
(() => {
  const cfgEl = document.getElementById('cf-cro-config');
  if (!cfgEl) return;
  const cfg = JSON.parse(cfgEl.textContent);
  const S = cfg.strings;
  const TZ = 'Europe/Amsterdam';

  const ICON_BOTTLE = '<svg viewBox="76 8 132 267" fill="currentColor" aria-hidden="true"><path d="M152.28,269.73c-6.65.32-13.68.32-20.32,0l-7.11-.08-6.35-.34-4.31-.37-10.38-1.26c-4.39-.53-8.46-3.25-8.48-7.62l-.15-33.38c-6.59-16.58-12.25-33.56-13.49-51.18-.19-2.62-.53-4.94-.14-7.53.41-2.76.36-5.45,1.1-8.32,3.01-11.72,5.32-23.34,6.01-35.42v-20.64c-.62-10.36-1.9-20.41-4.48-30.49-1.39-5.42-2.66-10.46-2.65-15.99l.02-10.63.39-5.98c.3-4.65,1.12-9.19,3.66-13.35l2.84-3.81c4.9-5.32,12.01-7.99,19.63-8.61l14.38-1.17,4.8-.33h29.97s4.41.33,4.41.33l13.97,1.18c16.66,1.41,25.16,10.69,26.16,25.34l.37,5.35v12.02c.02,9.12-5.74,26.04-6.75,41.93l-.36,5.7-.12,17.09.3,2.88c1.14,11.09,2.81,21.92,5.53,32.78.86,3.43,1.09,6.6,1.45,10.03v7.15c-.54,6.96-1.48,13.59-3.18,20.47-2.68,10.84-6.08,21.16-10.56,31.54l.02,32.47c0,1.6-.58,3.1-1.26,4.43-1.87,2.22-4.27,3.43-7.31,3.8l-9.64,1.19-4.28.39-6.07.27-7.63.13Z"/></svg>';   // the real Callowfit squeeze bottle (Untitled-2.svg, tight box)
  const ICON_BOX = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linejoin="round" aria-hidden="true"><path d="M3 8l9-4 9 4v9l-9 4-9-4z"/><path d="M3 8l9 4 9-4M12 12v9"/></svg>';
  const fill = (tpl, vars) => String(tpl || '').replace(/\[\[(\w+)\]\]/g, (_, k) => (vars[k] ?? ''));
  const plural = (n, one, other) => fill(n === 1 ? one : other, { count: n });
  // ponytail: wall-clock in Amsterdam via toLocaleString round-trip; no holiday calendar
  const ams = () => new Date(new Date().toLocaleString('en-US', { timeZone: TZ }));
  const isWorkday = (d) => d.getDay() >= 1 && d.getDay() <= 5;
  const fmtDate = (d) => new Intl.DateTimeFormat(cfg.locale, { weekday: 'short', day: 'numeric', month: 'short' }).format(d);
  const fmtWeekday = (d) => new Intl.DateTimeFormat(cfg.locale, { weekday: 'long' }).format(d);
  const money = (cents) => new Intl.NumberFormat(cfg.locale, { style: 'currency', currency: cfg.currency }).format(cents / 100);

  function shipDate() {
    const now = ams();
    const cut = new Date(now);
    cut.setHours(cfg.cutoffHour, cfg.cutoffMinute, 0, 0);
    const today = isWorkday(now) && now < cut;
    const d = new Date(now);
    d.setHours(12, 0, 0, 0);
    if (!today) do { d.setDate(d.getDate() + 1); } while (!isWorkday(d));
    return { d, today, msLeft: today ? cut - now : 0 };
  }
  const addBiz = (d, n) => { const r = new Date(d); while (n > 0) { r.setDate(r.getDate() + 1); if (isWorkday(r)) n--; } return r; };

  function renderCutoff() {
    const nodes = document.querySelectorAll('[data-cf-cutoff]');
    const shortNodes = document.querySelectorAll('[data-cf-cutoff-short]');
    if (!nodes.length && !shortNodes.length) return;
    const { d, today, msLeft } = shipDate();
    let text, short;
    if (today) {
      const m = Math.max(1, Math.ceil(msLeft / 60000));
      const h = Math.floor(m / 60);
      const time = h ? fill(S.time_hm, { h, m: m % 60 }) : fill(S.time_m, { m });
      text = fill(S.cutoff_before, { time });
      short = fill(S.cutoff_before_short, { time: h ? fill(S.time_hm_short, { h, m: m % 60 }) : fill(S.time_m, { m }) });
    } else {
      const tomorrow = ams(); tomorrow.setDate(tomorrow.getDate() + 1);
      const day = tomorrow.toDateString() === d.toDateString() ? S.tomorrow : fmtWeekday(d);
      text = fill(S.cutoff_after, { day });
      short = fill(S.cutoff_after_short, { day });
    }
    nodes.forEach((el) => { el.textContent = text; });
    shortNodes.forEach((el) => { el.textContent = short; });
  }

  function renderTimeline() {
    const roots = document.querySelectorAll('[data-cf-timeline]');
    if (!roots.length) return;
    const t = cfg.transit[cfg.country];
    const { d, today, msLeft } = shipDate();
    roots.forEach((root) => {
      if (!t) { root.hidden = true; return; }
      const m = Math.max(1, Math.ceil(msLeft / 60000)), h = Math.floor(m / 60);
      const time = h ? fill(S.time_hm, { h, m: m % 60 }) : fill(S.time_m, { m });
      root.querySelector('[data-cf-tl-intro]').textContent = today ? fill(S.tl_intro_before, { time }) : S.tl_intro_after;
      root.querySelector('[data-cf-tl-ship]').textContent = today ? S.tl_today : fmtDate(d);
      const from = addBiz(d, t[0]), to = addBiz(d, t[1]);
      root.querySelector('[data-cf-tl-deliver]').textContent = t[0] === t[1] ? fmtDate(from) : fmtDate(from) + ' - ' + fmtDate(to);
      root.hidden = false;
    });
    // free-shipping guarantee tile: per-country bottle count
    const freeG = cfg.free[cfg.country];
    document.querySelectorAll('[data-cf-fs-item]').forEach((li) => {
      if (!freeG) { li.hidden = true; return; }
      li.querySelector('[data-cf-fs-text]').textContent = fill(S.g_fs_s, { count: Math.ceil(freeG / cfg.gramsPerBottle) });
      li.hidden = false;
    });
  }

  function renderEta() {
    const nodes = document.querySelectorAll('[data-cf-eta]');
    const t = cfg.transit[cfg.country];
    if (!nodes.length || !t) return;
    const { d } = shipDate();
    const from = addBiz(d, t[0]), to = addBiz(d, t[1]);
    const text = t[0] === t[1]
      ? fill(S.eta_single, { from: fmtDate(from) })
      : fill(S.eta, { from: fmtDate(from), to: fmtDate(to) });
    nodes.forEach((el) => { el.textContent = text; (el.closest('p') || el).hidden = false; });
  }

  // Bottle deal (Maple launch, Oct 2026): 6 paid bottles -> free Mystery bottle (its own
  // product, added here and in checkout), then the 12th, 18th, 24th... paid bottle free.
  // INSTA-MAPLE (Instagram DM link) adds a free Maple at 6 paid bottles.
  // "Paid" = consumer bottles, never the Mystery bottle, minus the free Maple; the
  // discount function counts the same way, so bar and checkout agree.
  const isBottle = (i) => i.variant_id !== cfg.mysteryVariant && !/\(B2B\)/i.test(i.product_title || '') && Number(i.grams || 0) >= 200;
  function dealState(cart) {
    const items = cart.items || [];
    const qty = (v) => items.filter((i) => i.variant_id === v).reduce((n, i) => n + i.quantity, 0);
    const mapleCode = (cart.discount_codes || []).some((c) => new RegExp('^' + cfg.mapleCode + '(-[A-Z0-9]+)?$', 'i').test(String(c.code)));
    const mapleQty = qty(cfg.mapleVariant);
    const bottles = items.filter(isBottle).reduce((n, i) => n + i.quantity, 0);
    const mapleFree = mapleCode && mapleQty > 0 ? 1 : 0;
    return { items, mapleCode, mapleQty, paid: bottles - mapleFree, mystery: items.find((i) => i.variant_id === cfg.mysteryVariant) };
  }
  const freeCount = (paid) => Math.max(0, Math.floor(paid / cfg.packSize) - 1);

  function renderDeals(cart) {
    const roots = document.querySelectorAll('.cf-deals');
    if (!roots.length) return;
    const g = cfg.gramsPerBottle, pack = cfg.packSize;
    const weight = Number(cart.total_weight || 0);
    const { paid } = dealState(cart);
    const freeG = cfg.free[cfg.country] || 0;
    const freeBottles = freeG ? Math.ceil(freeG / g) : 0;
    const shipLeft = freeG ? Math.max(0, Math.ceil((freeG - weight) / g)) : null;
    const shipDone = shipLeft === 0;
    const free = freeCount(paid);
    const nextFree = paid < 2 * pack ? 2 * pack : Math.ceil((paid + 1) / pack) * pack;

    // bar target: the Mystery bottle at 6, then free shipping, then the next free bottle
    let target = paid < pack ? pack : (freeBottles && paid < freeBottles ? freeBottles : nextFree);
    const complete = shipDone && paid >= pack && paid % pack === 0;
    const pct = complete ? 100 : Math.max(0, Math.min(100, Math.round((paid / target) * 100)));

    let bottleText;
    if (paid === 0) bottleText = S.free_bottle_intro;
    else if (paid < pack) bottleText = plural(pack - paid, S.free_bottle_left_one, S.free_bottle_left_other);
    else {
      bottleText = free ? plural(free, S.free_bottle_in_cart_one, S.free_bottle_in_cart_other).replace(/!$/, '') + ' + ' + S.mystery_short : S.mystery_in_cart;
      bottleText += ' · ' + plural(nextFree - paid, S.next_free_one, S.next_free_other);
    }

    let shipText = '';
    if (freeG) shipText = shipDone ? S.shipping_free : plural(shipLeft, S.shipping_left_one, S.shipping_left_other);
    if (complete) { bottleText = S.deal_complete; shipText = ''; }

    let costText = '';
    const rate = cfg.rates[cfg.country];
    if (rate && cfg.currency === 'EUR' && !shipDone) {
      costText = fill(S.ship_cost, { country: cfg.countryName, amount: money(rate) });
      if (freeBottles) costText += ' (' + fill(S.ship_free_from, { count: freeBottles }) + ')';
    }

    roots.forEach((root) => {
      root.hidden = false;
      const set = (sel, txt) => { const el = root.querySelector(sel); if (el) { el.textContent = txt; (el.closest('p') || el).hidden = !txt; } };
      set('[data-cf-bottle]', bottleText);
      set('[data-cf-ship]', shipText);
      set('[data-cf-cost]', costText);
      const fillEl = root.querySelector('[data-cf-fill]');
      if (fillEl) fillEl.style.width = pct + '%';
      const bar = root.querySelector('[role="progressbar"]');
      if (bar) bar.setAttribute('aria-valuenow', String(pct));
      // milestones: the Mystery bottle at 6, a free bottle at 12/18/24, a box at free shipping
      const ticks = root.querySelector('[data-cf-ticks]');
      if (ticks) {
        let html = '';
        const tick = (n, cls, icon) => `<i class="cf-deals__tick ${cls}${paid >= n ? ' is-done' : ''}" style="left:${Math.min(100, (n / target) * 100)}%" title="${n}">${icon}</i>`;
        for (let n = pack; n <= target; n += pack) if (n !== freeBottles) html += tick(n, 'cf-deals__tick--bottle', ICON_BOTTLE);
        if (freeBottles && freeBottles <= target) html += tick(freeBottles, 'cf-deals__tick--ship', ICON_BOX);
        ticks.innerHTML = html;
      }
      root.classList.toggle('is-complete', pct >= 100);
    });
  }

  // Keeps the freebies in step with the cart: adds the Mystery bottle at 6 paid bottles and
  // removes it below 6; adds the Maple when INSTA-MAPLE is on the cart. A freebie the
  // customer removes themselves is not pushed back (sessionStorage, per visit).
  const ss = { get: (k) => { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
               set: (k, v) => { try { v === null ? sessionStorage.removeItem(k) : sessionStorage.setItem(k, v); } catch (e) {} } };
  async function syncFreebies(cart) {
    if (cfg.b2b || !cfg.mysteryVariant) return false;
    const { mapleCode, mapleQty, paid, mystery } = dealState(cart);
    const updates = {}, adds = [];
    if (paid >= cfg.packSize) {
      if (!mystery) {
        if (ss.get('cf-mystery') === 'added') ss.set('cf-mystery', 'off');   // we added it, it is gone: their choice
        else if (ss.get('cf-mystery') !== 'off') adds.push({ id: cfg.mysteryVariant, quantity: 1 });
      } else if (mystery.quantity > 1) updates[mystery.key] = 1;
    } else if (mystery) { updates[mystery.key] = 0; ss.set('cf-mystery', null); }
    if (mapleCode && !mapleQty && paid >= cfg.packSize) {
      if (ss.get('cf-maple') === 'added') ss.set('cf-maple', 'off');
      else if (ss.get('cf-maple') !== 'off') adds.push({ id: cfg.mapleVariant, quantity: 1 });
    }
    if (!adds.length && !Object.keys(updates).length) return false;
    const post = (url, body) => fetch(url, { method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
    if (Object.keys(updates).length) await post('/cart/update.js', { updates });
    if (adds.length) {
      const r = await post('/cart/add.js', { items: adds });
      if (r.ok) adds.forEach((a) => ss.set(a.id === cfg.mysteryVariant ? 'cf-mystery' : 'cf-maple', 'added'));
    }
    document.querySelector('cart-items')?.renderItems?.();
    return true;
  }

  let inflight = null;
  function refresh() {
    if (inflight) return inflight;
    inflight = fetch('/cart.js', { credentials: 'same-origin' })
      .then((r) => r.json())
      .then(async (cart) => {
        if (await syncFreebies(cart)) cart = await fetch('/cart.js', { credentials: 'same-origin' }).then((r) => r.json());
        renderDeals(cart);
        document.querySelectorAll('[data-cf-count]').forEach((el) => { el.textContent = cart.item_count > 0 ? `(${cart.item_count})` : ''; });
      })
      .catch(() => {})
      .finally(() => { inflight = null; });
    return inflight;
  }
  const later = () => { setTimeout(refresh, 400); setTimeout(refresh, 1500); };

  // discount code in cart (Cart AJAX API: POST /cart/update.js {discount}).
  // Not a <form>: the whole drawer already is one, and forms cannot nest.
  async function applyDiscount(box) {
    const input = box.querySelector('input');
    const err = box.querySelector('[data-cf-discount-error]');
    const code = (input.value || '').trim();
    if (!code) return;
    box.classList.add('is-loading');
    if (err) err.hidden = true;
    const post = (discount) => fetch('/cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount }),
    }).then((r) => r.json());
    try {
      const cart = await post(code);
      const codes = cart.discount_codes || [];
      const ok = codes.some((c) => c.code.toLowerCase() === code.toLowerCase() && c.applicable);
      if (!ok) {
        // drop the dead code, keep whatever was already applied
        await post(codes.filter((c) => c.applicable).map((c) => c.code).join(','));
        // review codes (CFDANK-*) only work with a Curry Mango in the cart; say so
        const curryMissing = /^CFDANK-/i.test(code) && !(cart.items || []).some((i) => i.variant_id === 47333408702681);
        if (err) { err.textContent = curryMissing ? S.discount_needs_curry : S.discount_invalid; err.hidden = false; }
        return;
      }
      document.querySelector('cart-items')?.renderItems();   // re-renders footer + totals
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    } finally { box.classList.remove('is-loading'); }
  }

  async function addRecommendation(btn) {
    const id = Number(btn.dataset.cfRecAdd);
    if (!id) return;
    btn.disabled = true;
    try {
      const r = await fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id, quantity: 1 }] }),
      });
      if (r.ok) document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
    } finally { btn.disabled = false; }
  }

  // merged rows (Shopify splits BXGY lines): set the total through update.js by line keys
  async function setMergedQuantity(row, quantity) {
    const keys = (row.dataset.cfKeys || '').split(',').filter(Boolean);
    if (keys.length < 2) return false;                 // single line: theme handles it
    const updates = {};
    keys.forEach((k, i) => { updates[k] = i === 0 ? quantity : 0; });
    row.classList.add('is-loading');
    const r = await fetch('/cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates, sections: 'main-cart', sections_url: location.pathname }),
    }).then((x) => x.json());
    const items = document.querySelector('cart-items');
    if (r.sections?.['main-cart'] && items) items.updateCartSections(new DOMParser().parseFromString(r.sections['main-cart'], 'text/html'));
    document.dispatchEvent(new CustomEvent('cart:update', { detail: r }));
    return true;
  }
  document.addEventListener('change', (e) => {
    const input = e.target;
    if (!input.matches?.('.cart-item[data-cf-keys] input[name="updates[]"]')) return;
    const row = input.closest('.cart-item');
    if ((row.dataset.cfKeys || '').split(',').filter(Boolean).length < 2) return;
    e.stopPropagation();                                 // keep the theme's line-index handler out
    setMergedQuantity(row, Math.max(0, parseInt(input.value, 10) || 0));
  }, true);
  document.addEventListener('click', (e) => {
    const btn = e.target.closest?.('.cart-item[data-cf-keys] cart-remove-button');
    if (!btn) return;
    const row = btn.closest('.cart-item');
    if ((row.dataset.cfKeys || '').split(',').filter(Boolean).length < 2) return;
    e.stopPropagation(); e.preventDefault();
    setMergedQuantity(row, 0);
  }, true);

  document.addEventListener('submit', (e) => {
    if ((e.target.getAttribute?.('action') || '').includes('/cart/add')) later();
  }, true);
  document.addEventListener('click', (e) => {
    const rec = e.target.closest?.('[data-cf-rec-add]');
    if (rec) { e.preventDefault(); addRecommendation(rec); return; }
    const toggle = e.target.closest?.('[data-cf-discount-toggle]');
    if (toggle) {
      e.preventDefault();
      const row = toggle.nextElementSibling;
      row.hidden = !row.hidden;
      toggle.setAttribute('aria-expanded', String(!row.hidden));
      if (!row.hidden) row.querySelector('input')?.focus();
      return;
    }
    const ex = e.target.closest?.('[data-cf-express-toggle]');
    if (ex) {
      e.preventDefault();
      const box = ex.closest('[data-cf-express]');
      box.classList.toggle('is-open');
      ex.setAttribute('aria-expanded', String(box.classList.contains('is-open')));
      return;
    }
    const apply = e.target.closest?.('[data-cf-discount-apply]');
    if (apply) { e.preventDefault(); applyDiscount(apply.closest('[data-cf-discount]')); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' && e.target.matches?.('[data-cf-discount] input')) { e.preventDefault(); applyDiscount(e.target.closest('[data-cf-discount]')); }
  });
  ['ajaxProduct:added', 'cart:update', 'cart:refresh', 'cart:updated', 'shopify:section:load'].forEach((ev) =>
    document.addEventListener(ev, later));

  // Klaviyo footer form ships an English placeholder; swap it for the locale string once it renders
  const fixNewsletter = () => {
    document.querySelectorAll('.cf-newsletter-embed input[type="email"]').forEach((i) => { if (S.newsletter_placeholder && i.placeholder !== S.newsletter_placeholder) i.placeholder = S.newsletter_placeholder; });
  };
  new MutationObserver(fixNewsletter).observe(document.documentElement, { childList: true, subtree: true });

  // Vibel click id: ?vcid=... from an Instagram DM link is stored on the cart (hidden
  // attribute, ends up in the order's note_attributes) so Vibel can match the sale.
  const vcid = new URLSearchParams(location.search).get('vcid');
  if (vcid && /^[A-Za-z0-9_-]{4,64}$/.test(vcid)) {
    fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { _vcid: vcid, _vcid_at: new Date().toISOString() } }) }).catch(() => {});
  }

  const boot = () => { renderCutoff(); renderEta(); renderTimeline(); refresh(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  setInterval(() => { renderCutoff(); renderEta(); renderTimeline(); }, 15000);
})();
